<template>
    <div id="login-frame">
        <div class="auth-card columns">
            <div class="column is-5 left-side">
                <h1><strong>my</strong>247ed.com Portal</h1>
                <p><strong>Please use your credentials to login.</strong></p>
                <p class="mt-4"><i class="far fa-info-circle mr-2"></i>Please note this is for administrative and partner use only. Others should login at <a class="white" href="https://app.my247ed.com">https://app.my247ed.com</a>.</p>
                <p class="mt-5 is-size-7">Portal v{{version}}</p>
            </div>
            <div class="column is-7 right-side">
                <h6 class="mb-5">
                    <b-icon icon="lock" class="fa-sm mr-2"></b-icon>
                    Login
                </h6>

                <b-field>
                    <b-input placeholder="Email Address" type="email" icon="envelope" name="username" id="username" v-model="username"></b-input>
                </b-field>

                <b-field>
                    <b-input placeholder="Password" type="password" icon="key" name="password" id="password" v-model="password"></b-input>
                </b-field>

                <b-button type="is-primary" icon-right="sign-in-alt" class="mt-4 pr-5" :disabled="processing || !username || !password" @click="formSubmit">Login</b-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import pkg from '../../package.json';

    export default {
        name: 'login',
        data: function() {
            return {
                username: '',
                password: '',
                processing: false,
                version: pkg.version
            };
        },
        computed: {
            ...mapGetters(['currentUser'])
        },
        methods: {
            ...mapActions(['login']),
            formSubmit() {
                this.processing = true;
                this.login({username: this.username, password: this.password}).catch(err => {
                    if (err && err.message) {
                        this.$notify('error', 'Login Error', err.message, {duration: 5000, permanent: false});
                    } else if (err && err.error && err.error.text) {
                        this.$notify('error', 'Login Error', err.error.text, {duration: 5000, permanent: false});
                    } else if (err) {
                        this.$notify('error', 'Login Error', 'An unknown error occurred. Please try again later.', {duration: 5000, permanent: false});
                    }

                    setTimeout(() => {
                        this.processing = false;
                    }, 2000);
                });
            }
        },
        watch: {
            currentUser(val) {
                if (val && val.id) {
                    this.$router.push('/secure');
                }
            }
        },
        mounted() {
            this.$resetCards();
        }
    };
</script>

<style lang="scss" scoped>
    #login-frame {
        display: flex;
        min-height: 100vh;
        align-items: center;
        justify-content: center;

        background: #224C74 radial-gradient(#336699, #1e385c);

        .auth-card {
            margin: 2rem;
            border-radius: 5px;
            box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.3);

            .left-side {
                background-color: #336699;
                padding: 3rem 2rem 3rem 2.5rem;
                border-radius: 5px 0 0 5px;
                color: white;

                strong {
                    color: white;
                }

                h1 {
                    font-weight: normal;
                    font-size: 2.2rem !important;
                    margin-bottom: 3rem;

                    strong {
                        font-weight: 900;
                    }
                }

                a {
                    color: white;
                }
            }

            .right-side {
                background-color: #FFFFFF;
                padding: 3.5rem 3rem 4.5rem 3rem;
                border-radius: 0 5px 5px 0;

                font-size: 0.85rem;

                h6 {
                    font-size: 1.3rem;
                }
            }
        }
    }
</style>

